import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Button, Table, Message, Loader, Icon, Checkbox } from 'semantic-ui-react';
import DisplayHeader from '../FileDnD/FilesID/DisplayHeader';
import API_Root from '../Constants/API_Root';
import API_Root_Lambda from '../Constants/API_Root_Lambda';

class GrantTeamAccessModalBody extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            success: null,

            // GRANT (one team only)
            selectedTeamId: null,
            selectedAccessLevels: this.getDefaultAccessLevels(),
            accessOpen: false, // grant dropdown open

            // EXISTING ACL
            acl: [],

            // EDIT (per-row UI)
            editAccessLevelsByRow: {}, // row.id -> array
            accessOpenByRow: {},       // row.id -> boolean
        };
    }

    getDefaultAccessLevels = () => {
        const mi = this.props.modalInfo;
        const hasDef = mi && typeof mi.defaultAccessLevel !== 'undefined';
        const def = hasDef ? mi.defaultAccessLevel : ['read'];
        return Array.isArray(def) ? def : [def];
    };

    componentDidMount() {
        this.fetchACL();
    }

    endpoint = (key) => {
        const defaults = {
            listEndpoint: 'api/api-spreadsheets-team-resource-access/list',
            grantEndpoint: 'api/api-spreadsheets-team-resource-access/grant',
            updateEndpoint: 'api/api-spreadsheets-team-resource-access/update',
            revokeEndpoint: 'api/api-spreadsheets-team-resource-access/revoke',
        };
        const cfg = (this.props.modalInfo && this.props.modalInfo.modalConfig) || {};
        return (cfg[key] || defaults[key]).replace(/^[\/]+/, '');
    };

    fetchACL = () => {
        const modalInfo = this.props.modalInfo;
        if (!modalInfo) return;

        this.setState({ loading: true, error: null, success: null });

        fetch(API_Root_Lambda + this.endpoint('listEndpoint'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
                email: localStorage.getItem('email'),
                token: localStorage.getItem('token'),
                resource_type: modalInfo.resourceType,
                resource_pk: modalInfo.resourcePK,
            }),
        })
            .then((res) => (res.ok ? res.json() : Promise.reject(res)))
            .then((data) => {
                const list = Array.isArray(data) ? data : (data.results || []);
                const editMap = {};
                const openMap = {};
                for (let i = 0; i < list.length; i++) {
                    const row = list[i];
                    const v = row && row.access_level;
                    editMap[row.id] = Array.isArray(v) ? v.slice() : (v ? [v] : []);
                    openMap[row.id] = false;
                }
                this.setState({
                    acl: list,
                    loading: false,
                    editAccessLevelsByRow: editMap,
                    accessOpenByRow: openMap,
                });
            })
            .catch(() => this.setState({ error: 'Failed to load access list. Please try again.', loading: false }));
    };

    teamOptions = () => {
        const teamInfo = this.props.teamInfo || [];
        return teamInfo.map((t) => ({
            key: t.id,
            value: t.id,
            text: (t.name || 'Team') + ' (ID: ' + (t.team_hash || t.id) + ')',
        }));
    };

    // CRUD Access options
    allAccessOptions = () => ([
        { key: 'read',   value: 'read',   text: 'Read' },
        { key: 'create', value: 'create', text: 'Create' },
        { key: 'update', value: 'update', text: 'Update' },
        { key: 'delete', value: 'delete', text: 'Delete' },
    ]);

    // ===== Grant helpers =====
    selectAllAccessLevels = () => {
        const all = this.allAccessOptions().map((o) => o.value);
        this.setState({ selectedAccessLevels: all });
    };

    clearAllAccessLevels = () => this.setState({ selectedAccessLevels: [] });

    toggleAccessLevel = (value) => {
        const arr = (this.state.selectedAccessLevels || []).slice();
        const i = arr.indexOf(value);
        if (i >= 0) arr.splice(i, 1); else arr.push(value);
        this.setState({ selectedAccessLevels: arr });
    };

    // ===== Edit helpers (per row) =====
    setRowAccessOpen = (rowId, open) => {
        const m = Object.assign({}, this.state.accessOpenByRow);
        m[rowId] = open;
        this.setState({ accessOpenByRow: m });
    };

    toggleRowAccessLevel = (rowId, value) => {
        const map = Object.assign({}, this.state.editAccessLevelsByRow);
        const arr = (map[rowId] || []).slice();
        const i = arr.indexOf(value);
        if (i >= 0) arr.splice(i, 1); else arr.push(value);
        map[rowId] = arr;
        this.setState({ editAccessLevelsByRow: map });
    };

    selectAllRowAccessLevels = (rowId) => {
        const all = this.allAccessOptions().map((o) => o.value);
        const map = Object.assign({}, this.state.editAccessLevelsByRow);
        map[rowId] = all;
        this.setState({ editAccessLevelsByRow: map });
    };

    clearAllRowAccessLevels = (rowId) => {
        const map = Object.assign({}, this.state.editAccessLevelsByRow);
        map[rowId] = [];
        this.setState({ editAccessLevelsByRow: map });
    };

    // ===== API actions =====
    onGrant = () => {
        const selectedTeamId = this.state.selectedTeamId;
        const levels = this.state.selectedAccessLevels;

        if (!selectedTeamId) {
            this.setState({ error: 'Please select a team first.', success: null });
            return;
        }
        if (!levels || levels.length === 0) {
            this.setState({ error: 'Select at least one access level.', success: null });
            return;
        }

        const modalInfo = this.props.modalInfo;

        const payload = {
            resource_type: modalInfo.resourceType,
            resource_pk: modalInfo.resourcePK,
            team_pk: selectedTeamId,
            user_pk: localStorage.getItem('email'),
            access_level: levels, // array
            email: localStorage.getItem('email'),
            token: localStorage.getItem('token'),
        };

        this.setState({ loading: true, error: null, success: null });

        fetch(API_Root_Lambda + this.endpoint('grantEndpoint'), {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        })
            .then((res) => (res.ok ? res.json() : res.json().then((e) => Promise.reject(e))))
            .then(() => {
                this.setState({ success: 'Access granted successfully.', loading: false });
                this.fetchACL(); // will hide grant toolbar if ACL now has a row
            })
            .catch((err) => {
                const msg = (err && (err.detail || err.error || err.message)) || 'Failed to grant access.';
                this.setState({ error: msg, loading: false });
            });
    };

    onEdit = (rowId) => {
        const arr = this.state.editAccessLevelsByRow[rowId] || [];
        if (!arr.length) {
            this.setState({ error: 'Please select at least one access level.', success: null });
            return;
        }

        this.setState({ loading: true, error: null, success: null });

        fetch(API_Root_Lambda + this.endpoint('updateEndpoint'), {
            method: 'POST',
            body: JSON.stringify({
                id: rowId,
                access_level: arr, // array
                email: localStorage.getItem('email'),
                token: localStorage.getItem('token'),
                resource_type: this.props.modalInfo.resourceType,
                resource_pk: this.props.modalInfo.resourcePK
            }),
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        })
            .then((res) => (res.ok ? res.json() : res.json().then((e) => Promise.reject(e))))
            .then(() => {
                // this.setState({ success: 'Access updated.', loading: false });
                // this.fetchACL();
                // update local baseline so the Edit button disables immediately
                const rowIdNum = rowId;
                const newLevels = (this.state.editAccessLevelsByRow[rowIdNum] || []).slice();
                const acl = (this.state.acl || []).map(r => {
                    if (r.id === rowIdNum) {
                         return Object.assign({}, r, { access_level: newLevels });
                    }
                        return r;
                    });
                const openMap = Object.assign({}, this.state.accessOpenByRow);
                openMap[rowIdNum] = false; // close the dropdown after save
                this.setState({
                        success: 'Access updated.',
                        loading: false,
                        acl: acl,
                        accessOpenByRow: openMap
                });
                // You can keep or remove the refetch. Keeping it ensures server truth.
                this.fetchACL();
            })
            .catch((err) => this.setState({ error: (err && err.detail) || 'Failed to update access.', loading: false }));
    };

    onRevoke = (entryId) => {
        this.setState({ loading: true, error: null, success: null });

        fetch(API_Root_Lambda + this.endpoint('revokeEndpoint'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ email: localStorage.getItem('email'),
                token: localStorage.getItem('token'),
                resource_type: this.props.modalInfo.resourceType,
                resource_pk: this.props.modalInfo.resourcePK,
                id: entryId
            }),
        })
            .then((res) => (res.ok ? res.json().catch(() => ({})) : res.json().then((e) => Promise.reject(e))))
            .then(() => {
                this.setState({ success: 'Access revoked.', loading: false });
                this.fetchACL(); // if ACL becomes empty, grant toolbar will show again
            })
            .catch((err) => this.setState({ error: (err && err.detail) || 'Failed to revoke access.', loading: false }));
    };

    // ===== Renders =====
    renderAccessLevelDropdown() {
        const opts = this.allAccessOptions();
        const safeOpts = Array.isArray(opts) && opts.length ? opts : [{ key: 'read', value: 'read', text: 'Read' }];
        const selected = this.state.selectedAccessLevels || [];
        const names = safeOpts.filter((o) => selected.indexOf(o.value) >= 0).map((o) => o.text);
        const label = names.length ? names.join(', ') : 'No levels selected';

        return (
            <div>
                <div style={{ fontFamily: 'Lato', fontSize: 14, color: '#5E645E', margin: '0 0 6px 0' }}>
                    Access Level
                </div>

                <Dropdown
                    selection
                    multiple
                    closeOnChange={false}
                    open={this.state.accessOpen}
                    onOpen={() => this.setState({ accessOpen: true })}
                    onClose={() => this.setState({ accessOpen: false })}
                    text={label}
                    icon="dropdown"
                    style={{ width: '100%' }}
                >
                    <Dropdown.Menu>
                        <div
                            className="item"
                            style={{
                                padding: '6px 10px',
                                borderBottom: '1px solid rgba(34,36,38,.1)',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <div style={{ fontSize: 13, color: '#5E645E' }}>{label}</div>
                            <div>
                                <a
                                    style={{ fontSize: 12, marginRight: 12, cursor: 'pointer' }}
                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.selectAllAccessLevels(); }}
                                >
                                    Select All
                                </a>
                                <a
                                    style={{ fontSize: 12, cursor: 'pointer' }}
                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.clearAllAccessLevels(); }}
                                >
                                    Clear
                                </a>
                            </div>
                        </div>

                        <Dropdown.Divider />

                        {safeOpts.map((o) => {
                            const checked = selected.indexOf(o.value) >= 0;
                            return (
                                <Dropdown.Item
                                    key={o.value}
                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.toggleAccessLevel(o.value); }}
                                >
                                    <Checkbox
                                        checked={checked}
                                        label={o.text}
                                        onChange={(e) => { e.preventDefault(); e.stopPropagation(); this.toggleAccessLevel(o.value); }}
                                    />
                                </Dropdown.Item>
                            );
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }

    normalizeLevels = (arr) => {
        const a = Array.isArray(arr) ? arr.slice() : [];
        a.sort(); // consistent order
        return a;
    };

    getOriginalRowLevels = (rowId) => {
        const row = (this.state.acl || []).find(r => r.id === rowId);
        return row ? (Array.isArray(row.access_level) ? row.access_level : (row.access_level ? [row.access_level] : [])) : [];
    };

    hasRowChanged = (rowId) => {
        const edited = this.normalizeLevels(this.state.editAccessLevelsByRow[rowId] || []);
        const original = this.normalizeLevels(this.getOriginalRowLevels(rowId));
        if (edited.length !== original.length) return true;
        for (let i = 0; i < edited.length; i++) {
            if (edited[i] !== original[i]) return true;
        }
        return false;
    };

    renderRowAccessDropdown(row) {
        const rowId = row.id;
        const opts = this.allAccessOptions();
        const safeOpts = Array.isArray(opts) && opts.length ? opts : [{ key: 'read', value: 'read', text: 'Read' }];

        const selected = this.state.editAccessLevelsByRow[rowId] || [];
        const names = safeOpts.filter((o) => selected.indexOf(o.value) >= 0).map((o) => o.text);
        const label = names.length ? names.join(', ') : 'No levels selected';
        const isOpen = !!this.state.accessOpenByRow[rowId];

        return (
            <Dropdown
                selection
                multiple
                closeOnChange={false}
                open={isOpen}
                onOpen={() => this.setRowAccessOpen(rowId, true)}
                onClose={() => this.setRowAccessOpen(rowId, false)}
                text={label}
                icon="dropdown"
                style={{ width: '100%' }}
            >
                <Dropdown.Menu>
                    <div
                        className="item"
                        style={{
                            padding: '6px 10px',
                            borderBottom: '1px solid rgba(34,36,38,.1)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <div style={{ fontSize: 13, color: '#5E645E' }}>{label}</div>
                        <div>
                            <a
                                style={{ fontSize: 12, marginRight: 12, cursor: 'pointer' }}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.selectAllRowAccessLevels(rowId); }}
                            >
                                Select All
                            </a>
                            <a
                                style={{ fontSize: 12, cursor: 'pointer' }}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.clearAllRowAccessLevels(rowId); }}
                            >
                                Clear
                            </a>
                        </div>
                    </div>

                    {/*<Dropdown.Divider />*/}

                    {safeOpts.map((o) => {
                        const checked = selected.indexOf(o.value) >= 0;
                        return (
                            <Dropdown.Item
                                key={o.value}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.toggleRowAccessLevel(rowId, o.value); }}
                            >
                                <Checkbox
                                    checked={checked}
                                    label={o.text}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); this.toggleRowAccessLevel(rowId, o.value); }}
                                />
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    // Only show grant when NO team is associated yet (one team per resource rule)
    renderGrantToolbar() {
        const selectedTeamId = this.state.selectedTeamId;
        return (
            <div className="row" style={{ marginBottom: 12 }}>
                <div className="col-sm-6">
                    <div style={{ fontFamily: 'Lato', fontSize: 14, color: '#5E645E', margin: '0 0 6px 0' }}>
                        Select Team
                    </div>
                    <Dropdown
                        selection
                        placeholder="Choose a team"
                        options={this.teamOptions()}
                        value={selectedTeamId}
                        onChange={(_, data) => this.setState({ selectedTeamId: data.value })}
                        style={{ width: '100%' }}
                    />
                </div>

                <div className="col-sm-3">
                    {this.renderAccessLevelDropdown()}
                </div>

                <div className="col-sm-3" style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <Button color="green" onClick={this.onGrant} style={{ width: '100%' }}>
                        <Icon name="check" /> Grant Access
                    </Button>
                </div>
            </div>
        );
    }

    renderTable() {
        const acl = this.state.acl;
        if (!acl || acl.length === 0) {
            return <Message info content="No team access yet for this resource." />;
        }

        return (
            <Table celled striped compact size="small">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Team</Table.HeaderCell>
                        <Table.HeaderCell>Access</Table.HeaderCell>
                        <Table.HeaderCell>Updated</Table.HeaderCell>
                        <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {acl.map((row) => (
                        <Table.Row key={row.id}>
                            <Table.Cell>{row.team_name || ('Team ' + (row.team_hash || row.team_pk))}</Table.Cell>
                            <Table.Cell>{this.renderRowAccessDropdown(row)}</Table.Cell>
                            <Table.Cell>{row.updated_dt || '-'}</Table.Cell>
                            <Table.Cell>
                                <Button
                                   basic
                                   color="blue"
                                   size="small"
                                   onClick={() => this.onEdit(row.id)}
                                   disabled={!this.hasRowChanged(row.id)}
                                >
                                    <Icon name="edit" /> Edit
                                </Button>
                                <Button basic color="red" size="small" onClick={() => this.onRevoke(row.id)} style={{ marginLeft: 8 }}>
                                    <Icon name="trash" /> Revoke
                                </Button>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        );
    }

    render() {
        const modalInfo = this.props.modalInfo;
        const loading = this.state.loading;
        const error = this.state.error;
        const success = this.state.success;
        const aclCount = (this.state.acl && this.state.acl.length) || 0;

        return (
            <div className="filesIDDisplayBox">
                <DisplayHeader
                    header={
                        'Manage Access — ' +
                        ((modalInfo && modalInfo.resourceType ? modalInfo.resourceType : 'resource') || 'resource')
                    }
                />

                {error ? (
                    <Message negative icon>
                        <Icon name="warning circle" />
                        <Message.Content>{error}</Message.Content>
                    </Message>
                ) : null}

                {success ? (
                    <Message positive icon>
                        <Icon name="check circle" />
                        <Message.Content>{success}</Message.Content>
                    </Message>
                ) : null}

                {/* SHOW GRANT ONLY IF NO TEAM IS ASSOCIATED YET */}
                {!loading && aclCount === 0 ? this.renderGrantToolbar() : null}

                {loading ? (
                    <div style={{ padding: '40px 0', textAlign: 'center' }}>
                        <Loader active inline="centered" />
                        <div style={{ marginTop: 12 }}>Loading access list…</div>
                    </div>
                ) : (
                    this.renderTable()
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    modalInfo: state.mainState.modalInfo,
    teamInfo: state.mainState.teamInfo,
});

export default connect(mapStateToProps)(GrantTeamAccessModalBody);
